import { useState, useEffect } from "react"; 
import axios from "axios";
import { Link } from "react-router-dom";

function CarPage() {
  const [cars, setCars] = useState([]);

  useEffect(() => {
    fetchCars();
  }, []);

  const fetchCars = () => {
    axios
      // .get(`http://localhost:5000/cars`)
      .get(`${process.env.REACT_APP_API_URL}/cars`)
      .then((res) => setCars(res.data))
      .catch((err) => console.error("Error fetching cars:", err));
  };

  return (
    <div className="container mt-4 Detail">
      <div className="row g-1">
        {cars.map((car) => {
          let imageSrc = "https://via.placeholder.com/130"; // fallbacks

          try {
            const images = JSON.parse(car.images || "[]");
            if (images.length > 0) {
              // imageSrc = `http://localhost:5000${images[0]}`;
              imageSrc = `${process.env.REACT_APP_API_URL}${images[0]}`;
            }
          } catch (err) {
            console.error("Invalid JSON in car.images:", err);
          }

          return (
            <div key={car.id} className="col-6 col-md-3 mb-3">
              <Link
                to={`/cars/${car.slug}`}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <div className="card h-100">
                  <img
                    src={imageSrc}
                    alt={car.title}
                    className="card-img-top"
                    style={{ height: "130px", objectFit: "cover" }}
                  />
                  <div className="card-body p-1" style={{ lineHeight: "1", marginLeft: "10px"}}>
                    {/* <p
                      className="card-text mb-2"
                      style={{
                        fontSize: "14px",
                        color: "green",
                        fontWeight: "bold",
                      }}
                    >
                      ETB {Number(car.price).toLocaleString()}
                    </p> */}
                    <p
                      className="card-text mb-2"
                      style={{
                        fontSize: "12px",
                        color: "green",
                        fontWeight: "bold",
                      }}
                    >
                      {car.priceType === "Call" ? (
                        "Call for Offer"
                      ) : (
                        <>
                          {car.currency || "ETB"} {Number(car.price).toLocaleString()}
                        </>
                      )}
                    </p>
                    
                    <p className="card-title mb-1.5" style={{ fontSize: "14px" }}>
                      {car.title}
                    </p>
                    <p className="card-title mb-1" style={{ fontSize: "12px" }}>
                      {car.phone}
                    </p>
                    <p className="card-title mb-1" style={{ fontSize: "12px" }}>
                      {car.transmission} | {car.fuel}
                    </p>
                    <p className="card-text mb-1" style={{ fontSize: "10px" }}>
                      {car.location}
                    </p>
                  </div>
                </div>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default CarPage;


